// extracted by mini-css-extract-plugin
module.exports = {"model":"PasswordChange_model__3C8J0","content":"PasswordChange_content__mrE9t"};